import React from 'react';
export function Hero() {
  return <section className="w-full bg-transparent pt-2 pb-4 md:pt-2 md:pb-6" data-id="element-91">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-92">
        <div className="text-center space-y-2" data-id="element-93">
          <div className="flex justify-center mb-1" data-id="element-94">
            <span className="inline-flex items-center gap-1.5 border border-[#F87171]/50 rounded-full px-5 py-1.5 text-[#F87171] text-xs md:text-sm font-semibold bg-[#F87171]/10" data-id="element-95">
              🧠EDUMENTES
            </span>
          </div>

          <h1 className="md:text-5xl lg:text-6xl text-white font-[900] text-[24px] font-[Poppins,_sans-serif]" data-id="element-96">
            🏆 Tus sesiones resueltas todo el año.
          </h1>

          <div className="flex flex-col items-center pt-1 pb-1" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/1Szdts5Hqjg5XsmJza36Dm/da1e4957-8d57-4c23-9d32-cc32f1725fce.png" alt="Megapack Psicopedagogía Kit Profesional" className="w-full max-w-3xl h-auto mt-[5px] mb-[5px] pl-[60px] pr-[60px]" data-id="element-98" />
            <p className="md:text-xl mt-3 tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#B794D6] text-[14px]" data-id="element-99">
              Más de 800 páginas de actividades, evaluaciones e intervenciones
              listas para usar, organizadas para acompañarte durante todo el
              año.
            </p>
          </div>

          <div className="flex items-center justify-center gap-1.5 pt-2" data-id="element-100">
            <span className="text-yellow-400 text-sm" data-id="element-101">⭐⭐⭐⭐⭐</span>
            <span className="text-white text-sm font-semibold" data-id="element-102">4.9/5</span>
            <span className="text-gray-400 text-xs" data-id="element-103">
              Mas de 65 profesionales ya adquirieron este megapack hoy
            </span>
          </div>

          <div className="flex justify-center pt-2" data-id="element-104">
            <a href="#oferta-pro" className="inline-block bg-[#C084FC] hover:bg-[#9333EA] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 font-['Open_Sans',_sans-serif] text-[18px]" data-id="element-105">
              🧮→ ACCEDER AL MATERIAL
            </a>
          </div>

          <div className="flex flex-col items-center gap-2 text-xs md:text-sm text-white pt-2" data-id="element-106">
            <div className="flex flex-nowrap justify-center gap-2" data-id="element-107">
              <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-108">
                📄 Plantillas listas para usar
              </span>
              <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-109">
                ⚡ Ahorrá horas de planificación
              </span>
            </div>
            <span className="flex items-center gap-1.5 border-2 border-[#9333EA] rounded-md px-3 py-1 whitespace-nowrap font-semibold" data-id="element-110">
              📊 Informes y seguimiento más rápidos
            </span>
          </div>
        </div>
      </div>
    </section>;
}